import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../store';
import { changeFavoriteAction } from '../../../store/offer';
import { FavoriteButton, IFavoriteButtonDispatchProps, IFavoriteButtonStoreProps } from './index';

const mapStateToProps = (state: IState): IFavoriteButtonStoreProps => ({
  agent: state.offerData.agent,
  checked: state.offerData.isFavorite,
  offer: state.offerData.offer,
});

const mapDispatchToProps = (dispatch: Dispatch<IState>): IFavoriteButtonDispatchProps => ({
  changeFavorite: () => dispatch(changeFavoriteAction()),
});

export const FavoriteButtonContainer = connect<
  IFavoriteButtonStoreProps,
  IFavoriteButtonDispatchProps,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any
>(
  mapStateToProps,
  mapDispatchToProps,
)(FavoriteButton);
